<template>
    <div class="">

         <!-- Abdullah responsive added mx-3  -->
        <div class="row no-gutters py-2 mb-3 ml-3">
          <div class="col-md-10 col-sm-12" >
            <h4 class="atlhr-dashboard-title mt-10">
                My <span class="black-title">Team</span>
                <span>
                    <a v-bind:href="$api_url">Dashboard</a>  / Leave and Attendance / My Team
                </span>
            </h4>
          </div>
        </div>

        <!-- Abdullah 20-05-26 added ml-3  -->
         <!-- Abdullah responsive added mx-md-3  -->
        <div class="mt-4 employee-tab leave-attendance-dashboard employee-investment-wrapper ml-md-3">
            <b-tabs pills content-class="" nav-class=" pr-2 m-2 leave-attendance-dashboard-tab" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white">

                <template >
                    <b-tab lazy>
                        <template active v-slot:title>

                            Leaves
                        </template>
                        <div class="tab-item-wrapper">
                            <all-leaves-front  :flg="gl"></all-leaves-front>
                        </div>
                    </b-tab>
                    <b-tab lazy>
                        <template active v-slot:title>

                            Attendance</template>
                        <div class="tab-item-wrapper">
                            <!-- <div class="mb-1 mt-5"><employees-attendance-import ></employees-attendance-import></div> -->

                            <employees-attendance-front ></employees-attendance-front>
                        </div>
                    </b-tab>
                    <b-tab lazy v-if="!is_line_manager && is_manager">
                        <template active v-slot:title>

                            Employee Profile</template>
                        <div class="tab-item-wrapper">
                            <all-employee-leave-attendance-wrapper-front ></all-employee-leave-attendance-wrapper-front>
                        </div>
                    </b-tab>

                            <!-- asfaq - 27-07-2025 - Start -->
                    <b-tab lazy>
                        <template active v-slot:title>

                            Compensatory Leaves</template>
                        <div class="tab-item-wrapper">

                            <l-a-ess-compensatory-leaves-list-all></l-a-ess-compensatory-leaves-list-all>
                        </div>
                    </b-tab>
                    <!-- asfaq - 27-07-2025 - End -->
                    <!--
                    <b-tab lazy>
                        <template active v-slot:title>

                            Reports
                        </template>
                        <div class="tab-item-wrapper">
                            leave data goes here
                        </div>
                    </b-tab>
                    -->

                </template>

            </b-tabs>

        </div>





    </div>
</template>
<script>


    export default{

        mounted() {
            this.$refs.trzcalendar;
        },
        props: [ 'flag',],
        components: {

        },
        data(){

            return {

                cu:window.location.href,
                ce:false,
                gl:0,
                is_line_manager : false,
                is_manager: false,


            }
        },
        methods:{


        checkIsManager: function()
            {
                if(!this.checkNet()) return false;

                axios.get(this.$api_url+'/front/ismanager' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    //alert(response.data);
                    if(response.data.is_manager == 1)
                    {
                        this.is_manager = true;

                        if(response.data.is_line_manager == 1)
                        {
                            this.is_line_manager = 1;
                        }
                    }

                }.bind(this)).catch(function (error){this.serverError(error);});
            },
        },
        created: function(){
            this.checkIsManager();

        },
        computed:
        {

        }
    }
</script>
